import React from 'react';
import { ErrorMessageProviderState } from 'shared/components/error/providers/states/error-message-provider-state';

const ErrorMessageProviderContext = React.createContext<ErrorMessageProviderState>({
  errorMsgTKey: null,
  setErrorMessage: () => {},
  setCustomErrorMessage() {},
});

export default ErrorMessageProviderContext;
